import { formatPostnummer } from '../../common/lib/formatPostnummer';
import { Adress } from '../types/dtos/VarderingarModel';

export const createAdressLine = (adress: Adress): string =>
  adress
    ? `${adress.gata} ${
        adress.lagenhetsnummer ? ` lgh ${adress.lagenhetsnummer}` : ''
      }, ${formatPostnummer(adress.postnummer)} ${adress.postort}`
    : 'Adress saknas';

export const createAdressLines = (adress: Adress): string[] =>
  adress
    ? [
        adress.lagenhetsnummer
          ? `${adress.gata} lgh ${adress.lagenhetsnummer}`
          : adress.gata,
        `${formatPostnummer(adress.postnummer)} ${adress.postort}`,
      ]
    : ['Adress saknas'];
